import { BinderSummary, PAGES } from "@dune/types";
import { DataTable, Input, useDebounce, useSidebar } from "@dune/ui";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useGetBinders } from "../../api/queries/binder.queries";
import { bindersListColumns } from "../../component/brokers/binders/columns/bindersListColumns";
import PageLayoutWithTabs from "../../component/layout/PageLayoutWithTabs";

const Binders = () => {
	const [searchInput, setSearchInput] = useState("");
	const navigate = useNavigate();
	const debouncedSearch = useDebounce(searchInput, 1000);
	const { state } = useSidebar();
	const isCollapsed = state === "collapsed";

	const { data } = useGetBinders();

	const filteredData =
		data?.filter((binder: BinderSummary) =>
			binder.reference?.toLowerCase().includes(debouncedSearch.toLowerCase()),
		) || [];

	return (
		<PageLayoutWithTabs title="Binders">
			<div className="space-y-6 flex-1 min-h-0 flex flex-col">
				{/* Search */}
				<div className="flex flex-row gap-2 w-1/2">
					<Input
						type="text"
						placeholder="Recherche rapide"
						value={searchInput}
						onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
							setSearchInput(e.target.value)
						}
					/>
				</div>

				{/* Table */}
				<div className="flex-1 min-h-0 w-full overflow-auto">
					<div className={`${isCollapsed ? "max-w-[92vw]" : "max-w-[80vw]"}`}>
						<DataTable
							columns={bindersListColumns}
							data={filteredData}
							noResultsText="Aucun binder trouvé"
							variant="default-with-sort"
							onRowClick={(row) =>
								navigate(PAGES.BINDERS.show.withParams(String(row.id)))
							}
						/>
					</div>
				</div>
			</div>
		</PageLayoutWithTabs>
	);
};

export default Binders;
